import {
  ListItem,
  ListItemText,
  List,
  AutocompleteGroupedOption,
  UseAutocompleteRenderedOption
} from '@mui/material';
import React from 'react';
import { FixedSizeList, ListOnItemsRenderedProps } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import LoadingSpinner from './Loader';
import './_style.paper.scss';

interface IInfiniteListWrapperProps {
  hasNextPage: boolean;
  items: any[];
  loadNextPage: () => void;
  getOptionProps: (
    renderedOption: UseAutocompleteRenderedOption<any>
  ) => React.HTMLAttributes<HTMLLIElement>;
  groupedOptions: any[] | AutocompleteGroupedOption<any>[];
  listboxProps: any;
}

const InfiniteListWrapper = ({
  hasNextPage,
  items,
  loadNextPage,
  getOptionProps,
  groupedOptions,
  listboxProps
}: IInfiniteListWrapperProps) => {
  //check if last visible item is equal to  last item in items array
  //load next page if last visible item is  equal to last item in items array
  const onItemsRendered = ({ visibleStopIndex }: ListOnItemsRenderedProps) => {
    if (visibleStopIndex + 1 >= items.length) {
      loadNextPage();
    }
  };
  // If there are more items to be loaded then add an extra row to hold a loading indicator.
  const itemCount = hasNextPage ? items.length + 1 : items.length;

  // Every row is loaded except for our loading indicator row.
  const isItemLoaded = (index: number) => !hasNextPage || index < items.length;
  // Render an item or a loading indicator.
  const Item = ({ index, style }: any) => {
    if (!isItemLoaded(index)) {
      return (
        <ListItem style={style} key={index} disablePadding>
          <LoadingSpinner />
        </ListItem>
      );
    } else if (!groupedOptions || index >= groupedOptions.length) {
      return null;
    } else {
      const option = groupedOptions[index];
      const name = option.label || 'no label';
      const id = option._id;

      return (
        <ListItem
          style={style}
          key={id}
          disablePadding
          {...getOptionProps({ option, index })}
        >
          <ListItemText primary={name} />
        </ListItem>
      );
    }
  };

  return (
    <InfiniteLoader
      isItemLoaded={isItemLoaded}
      itemCount={itemCount}
      loadMoreItems={() => {}}
    >
      {({ ref }) => (
        <div {...listboxProps}>
          <FixedSizeList
            className={'listbox'}
            height={400}
            itemCount={itemCount}
            itemSize={95}
            onItemsRendered={onItemsRendered}
            ref={ref}
            width={'100%'}
            innerElementType={List}
          >
            {Item}
          </FixedSizeList>
        </div>
      )}
    </InfiniteLoader>
  );
};

export default InfiniteListWrapper;
